const header = document.getElementById('site-header');
const progressBar = document.getElementById('progress-bar');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Three photographic studies reveal in sequence, then the final frame opens to the cover.
const motionCovers = document.querySelectorAll('.motion-cover');
// Move the editorial motifs with the reading rhythm; one frame serves all visible sections.
const motifSections = Array.from(document.querySelectorAll('.hero, .living, .nature, .outside, .sustain, .closing'));
let motifFrame = 0;
function updateMotifsOnScroll() {
  motifFrame = 0;
  if (reducedMotion.matches) return;
  const viewport = window.innerHeight;
  motifSections.forEach(section => {
    const bounds = section.getBoundingClientRect();
    if (bounds.bottom < 0 || bounds.top > viewport) return;
    const progress = Math.max(0, Math.min(1, (viewport - bounds.top) / (viewport + bounds.height)));
    section.style.setProperty('--motif-shift', `${Math.round((progress - .5) * 86)}px`);
  });
}
function queueMotifFrame() { if (!motifFrame) motifFrame = requestAnimationFrame(updateMotifsOnScroll); }
window.addEventListener('scroll', queueMotifFrame, { passive: true });
window.addEventListener('resize', queueMotifFrame);
reducedMotion.addEventListener('change', queueMotifFrame);
queueMotifFrame();
if ('IntersectionObserver' in window && !reducedMotion.matches) {
  const revealCover = async cover => {
    const images = Array.from(cover.querySelectorAll('.motion-frame img'));
    images.forEach(image => { image.loading = 'eager'; });
    await Promise.race([
      Promise.allSettled(images.map(image => image.decode())),
      new Promise(resolve => window.setTimeout(resolve, 1800))
    ]);
    if (!images.every(image => image.complete && image.naturalWidth > 0)) {
      cover.classList.add('motion-done');
      return;
    }
    cover.classList.add('motion-playing');
    const finalFrame = cover.querySelector('.motion-frame-final');
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      cover.classList.remove('motion-playing');
      cover.classList.add('motion-done');
    };
    finalFrame.addEventListener('animationend', event => {
      if (event.animationName === 'vv-cover-final') finish();
    }, { once: true });
    window.setTimeout(finish, 3800);
  };
  const coverObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      coverObserver.unobserve(entry.target);
      revealCover(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px 8% 0px' });
  motionCovers.forEach(cover => {
    cover.classList.add('motion-ready');
    coverObserver.observe(cover);
  });
}
window.addEventListener('load', () => {
  window.requestAnimationFrame(() => document.documentElement.classList.add('is-ready'));
});
let scrollQueued = false;

function updateScrollState() {
  const top = window.scrollY;
  header.classList.toggle('scrolled', top > 32);
  const length = document.documentElement.scrollHeight - window.innerHeight;
  progressBar.style.width = `${length > 0 ? Math.min(100, (top / length) * 100) : 0}%`;
  scrollQueued = false;
}

window.addEventListener('scroll', () => {
  if (!scrollQueued) {
    scrollQueued = true;
    window.requestAnimationFrame(updateScrollState);
  }
}, { passive: true });
updateScrollState();

const journeyLinks = Array.from(document.querySelectorAll('.mobile-nav a'));
const journeySections = ['inicio', 'productos', 'dentro', 'afuera']
  .map(id => document.getElementById(id))
  .filter(Boolean);
let journeyQueued = false;
function updateJourneyNav() {
  const threshold = window.innerHeight * .42;
  let current = '';
  for (const section of journeySections) {
    if (section.getBoundingClientRect().top <= threshold) current = section.id;
  }
  for (const link of journeyLinks) {
    if (link.hash === `#${current}`) link.setAttribute('aria-current', 'location');
    else link.removeAttribute('aria-current');
  }
  journeyQueued = false;
}
window.addEventListener('scroll', () => {
  if (!journeyQueued) {
    journeyQueued = true;
    window.requestAnimationFrame(updateJourneyNav);
  }
}, { passive: true });
updateJourneyNav();

const revealItems = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window && !reducedMotion.matches) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: .08 });
  revealItems.forEach(item => observer.observe(item));
} else {
  revealItems.forEach(item => item.classList.add('visible'));
}

const menuToggle = document.getElementById('menu-toggle');
const mobileNav = document.getElementById('mobile-nav');
function setMenu(open) {
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? (document.documentElement.lang === 'en' ? 'Close menu' : 'Cerrar menú') : (document.documentElement.lang === 'en' ? 'Open menu' : 'Abrir menú'));
  mobileNav.hidden = !open;
  document.body.classList.toggle('menu-open', open);
  header.classList.toggle('menu-active', open);
  if (open) mobileNav.querySelector('a')?.focus();
}
menuToggle.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
document.addEventListener('click', event => {
  if (menuToggle.getAttribute('aria-expanded') === 'true' && !mobileNav.contains(event.target) && !menuToggle.contains(event.target)) setMenu(false);
});
window.addEventListener('keydown', event => {
  if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
    setMenu(false);
    menuToggle.focus();
  }
  if (event.key === 'Tab' && menuToggle.getAttribute('aria-expanded') === 'true') {
    const focusables = [menuToggle, ...mobileNav.querySelectorAll('a')];
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
});

const languageToggle = document.getElementById('language-toggle');
const initialPageTitle = document.title;
const initialPageDescription = document.querySelector('meta[name="description"]')?.content || '';
const translated = Array.from(document.querySelectorAll('[data-en]'));
translated.forEach(element => { element.dataset.es = element.textContent.trim(); });
const staticAttributeTranslations = {
  "Vista Verde Ecovillage, inicio": "Vista Verde Ecovillage, home",
  "Navegación principal": "Main navigation",
  "Video real del paisaje aportado por el promotor": "Real landscape video supplied by the developer",
  "Elegir vista de villa y paisaje": "Choose villa and landscape view",
  "Zoom del croquis": "Sketch zoom",
  "Ubicar elementos del croquis": "Find features on the sketch",
  "Información sobre el plano": "Information about the plan",
  "Paisajes reales y visualizaciones conceptuales del entorno": "Real landscapes and conceptual visualizations of the surroundings",
  "Cerrar fotografía": "Close photograph",
  "Fotografía anterior": "Previous photograph",
  "Fotografía siguiente": "Next photograph",
  "Filtrar solares por superficie": "Filter plots by area",
  "Abrir Flora que nos rodea": "Open the surrounding flora",
  "Navegar Flora que nos rodea": "Browse surrounding flora",
  "Anterior": "Previous",
  "Siguiente": "Next",
  "Flora que nos rodea; desliza para explorar": "Surrounding flora; swipe to explore",
  "Abrir Fauna de campo": "Open farm animals",
  "Navegar Fauna de campo": "Browse farm animals",
  "Fauna de campo; desliza para explorar": "Farm animals; swipe to explore",
  "Abrir la experiencia propuesta Sendero de Reconexión": "Open the proposed Reconnection Trail experience",
  "Recorrido conceptual, sin ubicación ni distancia comprobadas": "Conceptual route; location and distance have not been verified",
  "Navegar imágenes del sendero": "Browse trail images",
  "Imagen anterior": "Previous image",
  "Imagen siguiente": "Next image",
  "Tres imágenes de una propuesta visual de senderismo; desliza para explorar": "Three images of a proposed hiking experience; swipe to explore",
  "Abrir Amenidades": "Open amenities",
  "Navegar Amenidades": "Browse amenities",
  "Amenidades; desliza para explorar": "Amenities; swipe to explore",
  "Navegar destinos de Bonao": "Browse Bonao destinations",
  "Arte, cascadas, río y rutas de Bonao; desliza para explorar": "Bonao art, waterfalls, river and trails; swipe to explore",
  "Escala del mapa": "Map scale",
  "Contexto satelital de Villa Reyes Frías en Google Maps": "Satellite context of Villa Reyes Frías on Google Maps",
  "Fotografía real del paisaje del entorno; no representa la vista desde este solar": "Real photograph of the surrounding landscape; not the view from this plot",
  "Fotografía real del paisaje del entorno": "Real photograph of the surrounding landscape",
  "Imagen conceptual de la copa amplia de un samán": "Conceptual image of the broad canopy of a saman tree",
  "Visualización conceptual de un roble y su sombra": "Conceptual visualization of a roble tree and its shade",
  "Visualización conceptual de un samán de amplia copa": "Conceptual visualization of a broad-canopy saman tree",
  "Visualización conceptual de cañas de bambú": "Conceptual visualization of bamboo canes",
  "Visualización conceptual de una caoba criolla": "Conceptual visualization of a native mahogany tree",
  "Visualización conceptual de vacas en un potrero": "Conceptual visualization of cows in a pasture",
  "Visualización conceptual de un caballo en un sendero": "Conceptual visualization of a horse on a path",
  "Visualización conceptual de gallinas en un jardín": "Conceptual visualization of hens in a garden",
  "Visualización conceptual de ovejos en el pasto": "Conceptual visualization of sheep in the grass",
  "Imagen editorial editada de un caminante frente a una loma boscosa; no documenta el predio": "Edited editorial image of a hiker facing forested hills; it does not document the property",
  "Visualización conceptual de un camino entre árboles y lomas": "Conceptual visualization of a path among trees and hills",
  "Fotografía editada de caminantes; referencia visual, no tomada en el predio": "Edited photograph of hikers; visual reference, not taken on the property",
  "Fotografía editada de un caminante en el bosque; referencia visual, no tomada en el predio": "Edited photograph of a forest hiker; visual reference, not taken on the property",
  "Imagen conceptual de una mesa de café abierta al paisaje": "Conceptual image of a café table open to the landscape",
  "Visualización conceptual de un café abierto al paisaje": "Conceptual visualization of a café open to the landscape",
  "Visualización conceptual de un restaurante de madera": "Conceptual visualization of a wood restaurant",
  "Visualización conceptual de un lago verde": "Conceptual visualization of a green lake",
  "Visualización conceptual de un pequeño mercado de productos frescos": "Conceptual visualization of a small fresh produce market",
  "Fotografía real aportada del paisaje regional de Bonao, no vista verificada desde el predio": "Real regional Bonao landscape photograph supplied by the developer; not a verified view from the property",
  "Fotografía real del Museo Cándido Bidó y la Plaza de la Cultura en Bonao, fuente municipal": "Real photograph of the Cándido Bidó Museum and Plaza de la Cultura in Bonao, municipal source",
  "Cabeza con sombrero y pájaros, pintura auténtica de Cándido Bidó catalogada por Centro León": "Head with Hat and Birds, authentic Cándido Bidó painting cataloged by Centro León",
  "Fotografías reales del interior y las obras de la Casa Museo Tiburcio, fuente municipal": "Real photographs of the interior and works at Casa Museo Tiburcio, municipal source",
  "Ilustración conceptual de una cascada tropical; no es una fotografía de los Saltos de Jima": "Conceptual illustration of a tropical waterfall; not a photograph of Jima Waterfalls",
  "Ilustración conceptual de un río de montaña; no es una fotografía del Río Fula": "Conceptual illustration of a mountain river; not a photograph of Fula River",
  "Fotografía real del paisaje regional aportada por el promotor; no muestra la Ruta Real": "Real regional landscape photograph supplied by the developer; it does not show Ruta Real"
};
const localizedAttributes = Array.from(document.querySelectorAll('[alt], [aria-label], [title]'))
  .flatMap(element => ['alt', 'aria-label', 'title']
    .filter(attribute => element.hasAttribute(attribute) && staticAttributeTranslations[element.getAttribute(attribute)])
    .map(attribute => ({ element, attribute, es: element.getAttribute(attribute), en: staticAttributeTranslations[element.getAttribute(attribute)] })));
function setLanguage(language) {
  document.documentElement.lang = language;
  translated.forEach(element => { element.textContent = element.dataset[language]; });
  localizedAttributes.forEach(({ element, attribute, es, en }) => element.setAttribute(attribute, language === 'en' ? en : es));
  languageToggle.textContent = language === 'es' ? 'EN' : 'ES';
  languageToggle.setAttribute('aria-label', language === 'es' ? 'Switch to English' : 'Cambiar a español');
  document.title = language === 'es' ? initialPageTitle : 'Vista Verde Ecovillage · Los Quemados, Bonao, Dominican Republic';
  document.querySelector('meta[name="description"]').content = language === 'es'
    ? initialPageDescription
    : 'Vista Verde Ecovillage: a vision for villas and land plots among trees in Los Quemados, Bonao. Project in development.';
  document.querySelector('.hero-image').setAttribute('aria-label', language === 'es'
    ? 'Recreación visual de terreno abierto y arbolado con montañas cercanas, basada en fotografías aportadas de Los Quemados'
    : 'Visual recreation of open, tree-dotted land with nearby mountains, based on photos provided from Los Quemados');
  document.getElementById('location-map').title = language === 'es'
    ? 'Referencia satelital de Los Quemados, Bonao'
    : 'Satellite reference of Los Quemados, Bonao';
  const showingOriginalPlan = document.getElementById('plot-canvas').classList.contains('is-original');
  document.querySelector('.plot-original-image').alt = language === 'es'
    ? (showingOriginalPlan ? 'Croquis original de Arturo con superficies, linderos, calles y entrada' : 'Croquis ilustrado de Arturo con solares identificados, calles, caño, área verde y entrada')
    : (showingOriginalPlan ? 'Arturo original plan with areas, boundaries, roads and entrance' : 'Illustrated Arturo plan with identified plots, roads, channel, green area and entrance');
  plotViewport.setAttribute('aria-label', language === 'es'
    ? 'Croquis interactivo de solares. Desplázate para recorrerlo y selecciona un marcador.'
    : 'Interactive plot sketch. Scroll to explore and select a marker.');
  document.getElementById('plot-zoom-out').setAttribute('aria-label', language === 'es' ? 'Alejar el croquis' : 'Zoom out of sketch');
  document.getElementById('plot-zoom-in').setAttribute('aria-label', language === 'es' ? 'Acercar el croquis' : 'Zoom into sketch');
  document.getElementById('plot-source-toggle').textContent = document.getElementById('plot-canvas').classList.contains('is-original')
    ? (language === 'es' ? 'Ver plano ilustrado' : 'View illustrated map')
    : (language === 'es' ? 'Ver plano original' : 'View original plan');
  menuToggle.setAttribute('aria-label', menuToggle.getAttribute('aria-expanded') === 'true'
    ? (language === 'es' ? 'Cerrar menú' : 'Close menu')
    : (language === 'es' ? 'Abrir menú' : 'Open menu'));
  renderPlotInterface();
  renderVillaExplorer();
}
languageToggle.addEventListener('click', () => setLanguage(document.documentElement.lang === 'es' ? 'en' : 'es'));

const weatherToggle = document.getElementById('weather-toggle');
const weatherPanel = document.getElementById('weather-panel');
const weatherClose = document.getElementById('weather-close');
const weatherUnit = document.getElementById('weather-unit');
let weatherData = null;
let weatherFahrenheit = false;
const weatherLabels = {
  es: { clear:'Despejado', cloud:'Nublado', part:'Parcialmente nublado', rain:'Lluvia', storm:'Tormenta', day:'Hoy', unavailable:'Clima no disponible ahora', updated:'Actualizado', wind:'Viento', rainLabel:'Precipitación' },
  en: { clear:'Clear', cloud:'Cloudy', part:'Partly cloudy', rain:'Rain', storm:'Storm', day:'Today', unavailable:'Weather unavailable now', updated:'Updated', wind:'Wind', rainLabel:'Precipitation' }
};
function weatherKind(code) {
  if (code >= 95) return ['storm','⛈'];
  if (code >= 51) return ['rain','☂'];
  if (code >= 3 || code >= 45) return ['cloud','☁'];
  if (code >= 1) return ['part','⛅'];
  return ['clear','☀'];
}
function formatWeatherTemp(value) {
  if (!Number.isFinite(value)) return '—';
  return `${Math.round(weatherFahrenheit ? value * 9 / 5 + 32 : value)}°`;
}
function renderWeather() {
  const language = document.documentElement.lang === 'en' ? 'en' : 'es';
  const labels = weatherLabels[language];
  weatherToggle.setAttribute('aria-label', language === 'en' ? 'View Bonao weather' : 'Ver clima de Bonao');
  weatherClose.setAttribute('aria-label', language === 'en' ? 'Close weather' : 'Cerrar clima');
  weatherUnit.setAttribute('aria-label', language === 'en' ? 'Change temperature unit' : 'Cambiar unidad de temperatura');
  weatherPanel.setAttribute('aria-label', language === 'en' ? 'Bonao weather' : 'Clima de Bonao');
  document.getElementById('weather-forecast').setAttribute('aria-label', language === 'en' ? 'Five-day forecast' : 'Pronóstico de cinco días');
  weatherUnit.textContent = weatherFahrenheit ? '°C' : '°F';
  if (!weatherData) {
    document.getElementById('weather-toggle-value').textContent = 'Bonao';
    document.getElementById('weather-condition').textContent = labels.unavailable;
    return;
  }
  const now = weatherData.current;
  const [kind, icon] = weatherKind(now.weather_code);
  document.querySelector('.weather-toggle-icon').textContent = icon;
  document.getElementById('weather-toggle-value').textContent = formatWeatherTemp(now.temperature_2m);
  document.getElementById('weather-icon').textContent = icon;
  document.getElementById('weather-temp').textContent = formatWeatherTemp(now.temperature_2m);
  document.getElementById('weather-condition').textContent = labels[kind];
  document.getElementById('weather-wind').textContent = `${Math.round(now.wind_speed_10m)} km/h`;
  document.getElementById('weather-rain').textContent = `${Number(now.precipitation).toFixed(1)} mm`;
  const days = weatherData.daily;
  document.getElementById('weather-forecast').replaceChildren(...days.time.slice(0,5).map((date, index) => {
    const item = document.createElement('div');
    item.className = 'weather-day';
    const day = index === 0 ? labels.day : new Intl.DateTimeFormat(language === 'en' ? 'en-US' : 'es-DO', { weekday:'short', timeZone:'UTC' }).format(new Date(`${date}T12:00:00Z`));
    const [, dayIcon] = weatherKind(days.weather_code[index]);
    item.innerHTML = `<span>${day}</span><b aria-hidden="true">${dayIcon}</b><strong>${formatWeatherTemp(days.temperature_2m_max[index])}</strong>`;
    return item;
  }));
  document.getElementById('weather-updated').textContent = `${labels.updated} · ${now.time.slice(11,16)} · Open-Meteo`;
}
function openWeather(open) {
  weatherPanel.hidden = !open;
  weatherToggle.setAttribute('aria-expanded', String(open));
  if (open && !weatherData) loadWeather();
}
async function loadWeather() {
  try {
    const response = await fetch('https://api.open-meteo.com/v1/forecast?latitude=18.9427&longitude=-70.4116&current=temperature_2m,precipitation,weather_code,wind_speed_10m&daily=weather_code,temperature_2m_max,temperature_2m_min&forecast_days=5&timezone=America%2FSanto_Domingo');
    if (!response.ok) throw new Error('Forecast unavailable');
    const data = await response.json();
    if (!Number.isFinite(data.current?.temperature_2m) || !Array.isArray(data.daily?.time)) throw new Error('Invalid forecast');
    weatherData = data;
  } catch (_) { weatherData = null; }
  renderWeather();
}
weatherToggle.addEventListener('click', () => openWeather(weatherPanel.hidden));
weatherClose.addEventListener('click', () => { openWeather(false); weatherToggle.focus(); });
weatherUnit.addEventListener('click', () => { weatherFahrenheit = !weatherFahrenheit; renderWeather(); });
document.addEventListener('click', event => { if (!weatherPanel.hidden && !weatherPanel.contains(event.target) && !weatherToggle.contains(event.target)) openWeather(false); });
document.addEventListener('keydown', event => { if (event.key === 'Escape' && !weatherPanel.hidden) { openWeather(false); weatherToggle.focus(); } });
languageToggle.addEventListener('click', renderWeather);
renderWeather();
loadWeather();

const villaExplorer = document.getElementById('villa-explorer');
const villaOpen = document.getElementById('villa-open');
const villaClose = document.getElementById('villa-close');
const villaImage = document.getElementById('villa-stage-image');
const villaVideo = document.getElementById('villa-stage-video');
const villaStage = document.querySelector('.villa-stage');
const villaViewButtons = Array.from(document.querySelectorAll('[data-villa-view]'));
const villaViews = {
  exterior: {
    image: '//vistaverde.do/cdn/shop/t/2/assets/villa-exterior-buildable.jpg?v=78645772852757587381791577208',
    es: ['VISUALIZACIÓN CONCEPTUAL', 'IDEA ARQUITECTÓNICA', 'Exterior tropical.', 'Escala contenida, aleros, ventilación cruzada, madera y piedra.', 'Visualización conceptual de villa tropical sencilla con galería sombreada, madera y piedra'],
    en: ['CONCEPT VISUALIZATION', 'ARCHITECTURAL IDEA', 'A tropical exterior.', 'Modest scale, deep eaves, cross ventilation, wood and stone.', 'Conceptual rendering of a modest tropical villa with shaded veranda, wood and stone']
  },
  interior: {
    image: '//vistaverde.do/cdn/shop/t/2/assets/villa-interior-bido-concepto.jpg?v=112221858673132548091791577208',
    es: ['MONTAJE CONCEPTUAL · ARTE DE CÁNDIDO BIDÓ', 'IDEA ARQUITECTÓNICA', 'Interior abierto al arte.', 'Madera cálida y una propuesta de ambientación inspirada en Cabeza con sombrero y pájaros (1982), obra real de Cándido Bidó catalogada por Centro León. El montaje no representa una villa construida.', 'Montaje conceptual de interior de villa con una reproducción inspirada en obra real de Cándido Bidó'],
    en: ['CONCEPTUAL MONTAGE · CÁNDIDO BIDÓ ART', 'ARCHITECTURAL IDEA', 'Open to art.', 'Warm wood and a proposed interior inspired by Head with Hat and Birds (1982), an authentic Cándido Bidó work cataloged by Centro León. The montage does not depict a built villa.', 'Conceptual villa interior montage with a reproduction inspired by a real Cándido Bidó work']
  },
  montanas: {
    image: '//vistaverde.do/cdn/shop/t/2/assets/paisaje-real-montanas.jpg?v=137745513836854170411791577208',
    es: ['FOTO REAL APORTADA', 'REFERENCIA DEL ENTORNO', 'Las montañas.', 'Una referencia real del paisaje aportada por el promotor. No confirma la vista desde un solar.', 'Fotografía real aportada de montañas y vegetación'],
    en: ['REAL PHOTO PROVIDED', 'LANDSCAPE REFERENCE', 'The mountains.', 'A real landscape reference provided by the developer. It does not confirm any plot view.', 'Real photo provided of mountains and vegetation']
  },
  terraza: {
    image: '//vistaverde.do/cdn/shop/t/2/assets/paisaje-real-terraza.jpg?v=146520217413864503021791577208',
    es: ['FOTO REAL APORTADA', 'REFERENCIA DEL ENTORNO', 'Una vista cercana.', 'Fotografía tomada desde una terraza. Su ubicación no representa una villa del proyecto.', 'Fotografía real de montaña vista desde una terraza con baranda blanca'],
    en: ['REAL PHOTO PROVIDED', 'LANDSCAPE REFERENCE', 'A nearby view.', 'Photographed from a terrace. Its location does not represent a project villa.', 'Real photo of mountains from a terrace with a white railing']
  },
  vegetacion: {
    image: '//vistaverde.do/cdn/shop/t/2/assets/paisaje-real-vegetacion.jpg?v=74231864269989601281791577208',
    es: ['FOTO REAL APORTADA', 'REFERENCIA DEL ENTORNO', 'Vegetación viva.', 'Palmas, flores y montaña: color que puede orientar un diseño sobrio.', 'Fotografía real de palmas, flores y montañas verdes'],
    en: ['REAL PHOTO PROVIDED', 'LANDSCAPE REFERENCE', 'Living vegetation.', 'Palms, flowers and mountain: color to guide a restrained design.', 'Real photo of palms, flowers and green mountains']
  },
  video: {
    video: true,
    es: ['VIDEO REAL APORTADO', 'REFERENCIA DEL ENTORNO', 'El paisaje en movimiento.', 'Un recorrido visual aportado como referencia. Reprodúcelo cuando quieras.', 'Video real aportado del paisaje de Bonao'],
    en: ['REAL VIDEO PROVIDED', 'LANDSCAPE REFERENCE', 'The landscape in motion.', 'A video provided for reference. Play it when you like.', 'Real landscape video provided by the developer']
  }
};
let activeVillaView = 'exterior';
function renderVillaExplorer() {
  const en = document.documentElement.lang === 'en';
  const view = villaViews[activeVillaView];
  const copy = view[en ? 'en' : 'es'];
  villaViewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.villaView === activeVillaView)));
  villaImage.hidden = !!view.video;
  villaVideo.hidden = !view.video;
  villaStage.classList.toggle('is-video', !!view.video);
  if (view.video) {
    villaVideo.setAttribute('aria-label', copy[4]);
  } else {
    villaVideo.pause();
    villaImage.src = view.image;
    villaImage.alt = copy[4];
  }
  document.getElementById('villa-stage-type').textContent = copy[0];
  document.getElementById('villa-stage-count').textContent = `${String(Object.keys(villaViews).indexOf(activeVillaView) + 1).padStart(2, '0')} / 06`;
  document.getElementById('villa-inspector-kind').textContent = copy[1];
  document.getElementById('villa-inspector-title').textContent = copy[2];
  document.getElementById('villa-inspector-description').textContent = copy[3];
}
function openVillaExplorer() {
  villaExplorer.hidden = false;
  villaOpen.setAttribute('aria-expanded', 'true');
  renderVillaExplorer();
  window.requestAnimationFrame(() => villaExplorer.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' }));
}
function closeVillaExplorer() {
  villaVideo.pause();
  villaExplorer.hidden = true;
  villaOpen.setAttribute('aria-expanded', 'false');
  villaOpen.focus();
}
villaOpen.addEventListener('click', () => villaExplorer.hidden ? openVillaExplorer() : closeVillaExplorer());
villaClose.addEventListener('click', closeVillaExplorer);
villaViewButtons.forEach(button => button.addEventListener('click', () => {
  activeVillaView = button.dataset.villaView;
  renderVillaExplorer();
}));
villaExplorer.addEventListener('keydown', event => {
  if (event.key === 'Escape') closeVillaExplorer();
});
renderVillaExplorer();


const map = document.getElementById('location-map');
const scaleButtons = Array.from(document.querySelectorAll('.scale-buttons button'));
scaleButtons.forEach(button => button.addEventListener('click', () => {
  const zoom = Number(button.dataset.zoom);
  if (!Number.isInteger(zoom) || zoom < 1 || zoom > 20) return;
  scaleButtons.forEach(item => item.classList.toggle('active', item === button));
  map.src = `https://maps.google.com/maps?q=18.897774,-70.453992&t=k&z=${zoom}&output=embed`;
}));

// Areas and reference points transcribed from CROQUIS ARTURO FINAL.pdf.
// VV identifiers are interface references; the drawing does not assign official lot numbers.
const plotRows = [
  [519,41.4,5.5],[567,45.2,9.3],[538,49,12.3],[547,52.2,14.8],[455,37.1,16.1],
  [573,55.8,18.3],[443,34.1,18.6],[477,30.5,21.1],[387,42.9,21.3],[496,27.5,23.8],
  [395,47.3,24],[495,25.3,26.3],[630,41,26.5],[434,22.4,29.7],[600,37.3,29.7],
  [649,50.2,30.9],[438,20.2,33.9],[515,47.5,34.7],[372,28.5,36.8],[478,17.1,37.5],
  [537,41.7,38.2],[383,32.2,40.1],[450,45.8,40.4],[423,24.7,40.9],[553,13.1,41.3],
  [431,29.3,43.8],[400,18,44.3],[486,36.4,45.6],[400,22,46.6],[609,5.1,48.3],
  [400,26.4,49.1],[588,9.8,50.2],[1250,39.2,50.8],[400,32.9,51.6],[965,48.8,52.4],
  [600,14.2,52.5],[505,18.3,54.3],[402,22.9,55.5],[450,28.5,58.4],[1994,57.3,59.1],
  [1000,43.4,61.2],[1000,31.9,63.4],[1183,70.3,66.2],[1000,39.3,69.4],[665,80,70.5],
  [592,61.2,18.1],[630,64.8,21.6],[656,69.2,25],[645,73.1,28.2],[719,77.8,31.7],
  [730,80.9,37.4],[694,83,43.3],[463,84.1,48.5],[459,84.2,54.5],[464,85.3,60],[621,85.8,66.3],
  [678,61.2,33.4],[512,65.2,36.3],[618,70.3,38.6],[616,72.6,43.8],[519,75,49.2],
  [503,72.7,56.4],[436,77.1,59],[790,64.6,47.9],[730,68.1,52.7],[734,60.6,43.0],
  [545,54.1,41.1],[534,56.1,38.9]
];
// VV-15 is the separate 600 m² parcel beside the shared green area.
// VV-45 identifies the entrance and is not offered as a plot.
const nonCommercialPlotIds = new Set(['VV-45']);
const plots = plotRows.map(([area, x, y], index) => ({ id: `VV-${String(index + 1).padStart(2, '0')}`, area, x, y }))
  .filter(plot => !nonCommercialPlotIds.has(plot.id));
const featuredPlotIds = ['VV-43', 'VV-40', 'VV-35', 'VV-16'];
const soldPlotIds = new Set(featuredPlotIds);
// No plot is commercially confirmed as available; remaining inventory is by inquiry.
const availablePlotIds = new Set([]);
const candidatePlotIds = ['VV-03', 'VV-04', 'VV-05', 'VV-09', 'VV-12', 'VV-21', 'VV-29', 'VV-37', 'VV-44', 'VV-53', 'VV-55', 'VV-66', 'VV-67'];
const candidatePlotSet = new Set(candidatePlotIds);
const plotViewport = document.getElementById('plot-viewport');
const plotCanvas = document.getElementById('plot-canvas');
const plotSourceToggle = document.getElementById('plot-source-toggle');
const plotHotspots = document.getElementById('plot-hotspots');
const plotList = document.getElementById('plot-list');
const plotZoomLabel = document.getElementById('plot-zoom-label');
const landscapeViews = [
  {src:'//vistaverde.do/cdn/shop/t/2/assets/terreno-real-referencia.jpg?v=14514244108052789221791577208', es:'Árboles y montañas', en:'Trees and mountains', position:'center 55%', kind:'real'},
  {src:'//vistaverde.do/cdn/shop/t/2/assets/paisaje-film-terraza.png?v=40762699352838573741791577208', es:'Montañas desde la terraza', en:'Mountains from the terrace', position:'center 42%', kind:'real'},
  {src:'//vistaverde.do/cdn/shop/t/2/assets/paisaje-real-montanas.jpg?v=137745513836854170411791577208', es:'Lomas y vegetación', en:'Hills and vegetation', position:'center 43%', kind:'real'},
  {src:'//vistaverde.do/cdn/shop/t/2/assets/paisaje-real-vegetacion.jpg?v=74231864269989601281791577208', es:'Vegetación de cerca', en:'Vegetation up close', position:'center 48%', kind:'real'},
  {src:'//vistaverde.do/cdn/shop/t/2/assets/paisaje-concepto-sendero.png?v=132114772523386747201791577208', es:'Sendero entre árboles', en:'Path among trees', position:'center 48%', kind:'concept'},
  {src:'//vistaverde.do/cdn/shop/t/2/assets/paisaje-concepto-vegetacion.png?v=96228150199201986331791577208', es:'Entre flores y lomas', en:'Flowers and hills', position:'center 48%', kind:'concept'}
];
const realLandscapeViewCount = landscapeViews.filter(view => view.kind === 'real').length;
let activeLandscapeView = 0;
const plotViewImage = document.getElementById('plot-view-image');
const plotViewDialog = document.getElementById('plot-view-dialog');
function renderLandscapeView() {
  const en = document.documentElement.lang === 'en';
  const view = landscapeViews[activeLandscapeView];
  const label = en ? view.en : view.es;
  const note = view.kind === 'real'
    ? (en ? 'Real supplied photo · cinematic color edit · area context, not this plot’s verified view' : 'Foto real aportada · edición de color cinematográfica · no vista comprobada desde este solar')
    : (en ? 'AI-generated visualization inspired by real area photos · not a real or verified plot view' : 'Visualización generada a partir de fotos reales del entorno · no es fotografía ni vista comprobada de este solar');
  plotViewImage.src = view.src;
  plotViewImage.style.objectPosition = view.position;
  plotViewImage.alt = `${label}. ${note}`;
  document.getElementById('plot-view-caption').textContent = view.kind === 'real'
    ? (en ? 'REAL AREA PHOTO · NOT THIS PLOT’S VIEW' : 'FOTO REAL DEL ENTORNO · NO VISTA DESDE EL SOLAR')
    : (en ? 'GENERATED VISUALIZATION · NOT A REAL VIEW' : 'VISUALIZACIÓN GENERADA · NO ES VISTA REAL');
  document.getElementById('plot-view-large').src = view.src;
  document.getElementById('plot-view-large').alt = `${label}. ${note}`;
  document.getElementById('plot-view-title').textContent = label;
  document.getElementById('plot-view-disclosure').textContent = note;
  document.getElementById('plot-view-count').textContent = `${activeLandscapeView + 1} / ${landscapeViews.length}`;
  document.getElementById('plot-view-open').setAttribute('aria-label', view.kind === 'real'
    ? (en ? 'Enlarge real area photograph' : 'Ampliar fotografía real del entorno')
    : (en ? 'Enlarge conceptual visualization' : 'Ampliar visualización conceptual'));
  document.getElementById('plot-view-close').setAttribute('aria-label', en ? 'Close photograph' : 'Cerrar fotografía');
}
function changeLandscapeView(direction) {
  activeLandscapeView = (activeLandscapeView + direction + landscapeViews.length) % landscapeViews.length;
  renderLandscapeView();
}
const plotSelectionLabel = document.getElementById('plot-selection-label');
const plotSelectionTitle = document.getElementById('plot-selection-title');
const plotAreaValue = document.getElementById('plot-area-value');
const plotInspector = plotSelectionLabel.closest('.plot-inspector');
const plotSave = document.getElementById('plot-save');
const plotShare = document.getElementById('plot-share');
const plotFeedback = document.getElementById('plot-feedback');
const plotResults = document.getElementById('plot-results');
const plotFilterButtons = Array.from(document.querySelectorAll('.plot-filters button'));
const zoomSteps = [1, 1.5, 2.2, 3];
let plotZoomIndex = 0;
let plotFilter = 'all';
let savedPlotId = null;
try { savedPlotId = window.localStorage.getItem('vista-verde-plot'); } catch (_) { /* Storage is optional. */ }
const queryPlotId = new URLSearchParams(window.location.search).get('solar');
const linkedPlot = plots.find(plot => plot.id === queryPlotId);
const savedPlot = plots.find(plot => plot.id === savedPlotId);
let selectedPlot = linkedPlot || savedPlot
  || plots.find(plot => !soldPlotIds.has(plot.id) && !candidatePlotSet.has(plot.id));
// A shared solar link must open the atlas even if an older URL retained an excursion anchor.
if (linkedPlot && window.location.hash && window.location.hash !== '#solares') {
  const url = new URL(window.location.href);
  url.hash = 'solares';
  window.history.replaceState(null, '', url);
  const showSharedSolar = () => {
    if (window.location.hash === '#solares') document.getElementById('solares').scrollIntoView({ behavior: 'instant', block: 'start' });
  };
  window.addEventListener('pageshow', () => {
    showSharedSolar();
    window.setTimeout(showSharedSolar, 150);
  }, { once: true });
}

function plotLanguage() { return document.documentElement.lang === 'en' ? 'en' : 'es'; }
function plotAreaText(area) {
  return `${new Intl.NumberFormat(plotLanguage() === 'es' ? 'es-DO' : 'en-US').format(area)} m²`;
}
function plotStatus(plot) {
  if (soldPlotIds.has(plot.id)) return 'sold';
  if (candidatePlotSet.has(plot.id)) return 'reserved';
  return 'consult';
}
function plotStatusText(status, en) {
  return en
    ? ({ sold: 'Sold', reserved: 'Reserved', consult: 'By inquiry' })[status]
    : ({ sold: 'Vendido', reserved: 'Reservado', consult: 'Por consultar' })[status];
}
function isPlotVisible(plot) {
  if (plotFilter === 'small') return plot.area < 500;
  if (plotFilter === 'medium') return plot.area >= 500 && plot.area < 700;
  if (plotFilter === 'large') return plot.area >= 700;
  return true;
}
function updatePlotCanvasWidth() {
  const zoomed = plotZoomIndex > 0;
  plotViewport.classList.toggle('is-zoomed', zoomed);
  const base = plotViewport.parentElement.clientWidth;
  plotCanvas.style.width = `${Math.round(base * zoomSteps[plotZoomIndex])}px`;
  plotViewport.classList.toggle('is-overview', window.innerWidth <= 650 && plotZoomIndex === 0);
  if (!zoomed) plotViewport.scrollTo({ left: 0, top: 0, behavior: 'instant' });
  plotZoomLabel.textContent = `${Math.round(zoomSteps[plotZoomIndex] * 100)}%`;
  document.getElementById('plot-zoom-out').disabled = plotZoomIndex === 0;
  document.getElementById('plot-zoom-in').disabled = plotZoomIndex === zoomSteps.length - 1;
}
function centerPlot(plot, smooth = true) {
  if (!plot || plotZoomIndex === 0) return;
  window.requestAnimationFrame(() => {
    const left = plotCanvas.clientWidth * plot.x / 100 - plotViewport.clientWidth / 2;
    const top = plotCanvas.clientHeight * plot.y / 100 - plotViewport.clientHeight / 2;
    plotViewport.scrollTo({ left: Math.max(0, left), top: Math.max(0, top), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto' });
  });
}
function centerMapPoint(x, y) {
  if (plotZoomIndex === 0) {
    plotZoomIndex = 1;
    updatePlotCanvasWidth();
  }
  window.requestAnimationFrame(() => {
    const left = plotCanvas.clientWidth * x / 100 - plotViewport.clientWidth / 2;
    const top = plotCanvas.clientHeight * y / 100 - plotViewport.clientHeight / 2;
    plotViewport.scrollTo({ left: Math.max(0, left), top: Math.max(0, top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });
}
function updatePlotUrl(plot) {
  const url = new URL(window.location.href);
  url.searchParams.set('solar', plot.id);
  url.hash = 'solares';
  window.history.replaceState(null, '', url);
}
function selectPlot(plot, userAction = true) {
  activeLandscapeView = (Number(plot.id.slice(-2)) * 7 + 2) % realLandscapeViewCount;
  selectedPlot = plot;
  plotFeedback.textContent = '';
  if (userAction) updatePlotUrl(plot);
  renderPlotInterface();
  centerPlot(plot, userAction);
}
function renderPlotInterface() {
  renderLandscapeView();
  if (!selectedPlot) return;
  const focusedPlotId = plotList.contains(document.activeElement) ? document.activeElement.dataset.plotId : null;
  const en = plotLanguage() === 'en';
  const selectedStatus = plotStatus(selectedPlot);
  plotInspector.dataset.state = selectedStatus;
  plotSelectionLabel.textContent = plotStatusText(selectedStatus, en);
  plotSelectionTitle.textContent = selectedPlot.id;
  plotAreaValue.textContent = plotAreaText(selectedPlot.area);
  const saved = savedPlotId === selectedPlot.id;
  plotSave.setAttribute('aria-pressed', String(saved));
  plotSave.hidden = selectedStatus !== 'consult';
  const saveLabel = en ? (saved ? 'Remove saved plot' : 'Save this plot') : (saved ? 'Quitar solar guardado' : 'Guardar este solar');
  const shareLabel = en ? 'Copy plot link' : 'Copiar enlace del solar';
  plotSave.setAttribute('aria-label', saveLabel);
  plotSave.title = saveLabel;
  plotShare.setAttribute('aria-label', shareLabel);
  plotShare.title = shareLabel;
  plotResults.textContent = en ? `${plots.filter(isPlotVisible).length} plot references` : `${plots.filter(isPlotVisible).length} referencias de solares`;
  plotFilterButtons.forEach(button => {
    const active = button.dataset.filter === plotFilter;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  plotHotspots.querySelectorAll('.lot-hotspot').forEach(button => {
    const plot = plots.find(item => item.id === button.dataset.id);
    const status = plotStatus(plot);
    button.hidden = !isPlotVisible(plot);
    const active = plot.id === selectedPlot.id;
    button.classList.toggle('is-selected', active);
    button.classList.toggle('is-featured', featuredPlotIds.includes(plot.id));
    button.classList.toggle('is-sold', status === 'sold');
    button.classList.toggle('is-candidate', status === 'reserved');
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', `${en ? 'Plot' : 'Solar'} ${plot.id}, ${plotAreaText(plot.area)}, ${plotStatusText(status, en)}`);
    button.dataset.tip = `${plot.id} · ${plotStatusText(status, en)} · ${plotAreaText(plot.area)}`;
  });
  plotList.replaceChildren();
  plots.filter(isPlotVisible).forEach(plot => {
    const status = plotStatus(plot);
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.plotId = plot.id;
    button.className = plot.id === selectedPlot.id ? 'active' : '';
    button.setAttribute('aria-pressed', String(plot.id === selectedPlot.id));
    button.setAttribute('aria-label', `${en ? 'Select plot' : 'Elegir solar'} ${plot.id}, ${plotAreaText(plot.area)}, ${plotStatusText(status, en)}`);
    const id = document.createElement('b');
    id.textContent = plot.id;
    const area = document.createElement('small');
    // Call out VV-15's corrected status; the other inquiry tiles keep the atlas compact.
    area.textContent = status === 'consult'
      ? (plot.id === 'VV-15' ? `${plotStatusText(status, en)} · ${plotAreaText(plot.area)}` : plotAreaText(plot.area))
      : plotStatusText(status, en);
    button.classList.toggle('is-sold', status === 'sold');
    button.classList.toggle('is-candidate', status === 'reserved');
    button.append(id, area);
    button.addEventListener('click', () => selectPlot(plot));
    plotList.append(button);
  });
  if (focusedPlotId) Array.from(plotList.children).find(button => button.dataset.plotId === focusedPlotId)?.focus({ preventScroll: true });
  const ambient = document.getElementById('ambient-toggle');
  ambient.textContent = en ? (ambienceEnabled ? 'Mute ambience' : 'Play ambience') : (ambienceEnabled ? 'Silenciar ambiente' : 'Activar ambiente');
}

// Same botanical points are drawn in the dossier. Coordinates follow the map image.
const meadowTreeRows = [
  [51, 74.8, .58], [54, 75.6, .73], [57.4, 75.2, .64], [60.8, 76.4, .76],
  [64.3, 77.3, .63], [67.5, 78.5, .76], [49.5, 77.8, .68], [52.8, 78.9, .78],
  [56.2, 78.2, .58], [59.6, 79.5, .85], [63, 80.2, .65], [66.7, 81.2, .76],
  [70.8, 78, .6], [73.4, 80.2, .7], [70.6, 82.1, .57], [59, 82.5, .72],
  [62.1, 83.4, .65], [65.1, 84.1, .62], [68.1, 84.8, .67], [66.3, 85.7, .6],
  [69.1, 86.1, .6]
];
const meadowTrees = document.getElementById('plot-meadow-trees');
meadowTreeRows.forEach(([x, y, radius]) => {
  const tree = document.createElement('span');
  tree.className = 'plot-meadow-tree';
  tree.style.left = `${x}%`;
  tree.style.top = `${y}%`;
  tree.style.width = `${radius * 2}%`;
  meadowTrees.append(tree);
});
const mapLandmarks = { green: [34.4, 32.7], channel: [50, 48], entrance: [84, 75] };
plotSourceToggle.addEventListener('click', () => {
  const original = plotCanvas.classList.toggle('is-original');
  const mapImage = plotCanvas.querySelector('.plot-original-image');
  mapImage.src = original
    ? '//vistaverde.do/cdn/shop/t/2/assets/croquis-original-recortado.png?v=163304995268793601891791577208'
    : '//vistaverde.do/cdn/shop/t/2/assets/croquis-site-alineado.png?v=31640559297812804371791577208';
  const en = plotLanguage() === 'en';
  mapImage.alt = en
    ? (original ? 'Arturo original plan with areas, boundaries, roads and entrance' : 'Illustrated Arturo plan with identified plots, roads, channel, green area and entrance')
    : (original ? 'Croquis original de Arturo con superficies, linderos, calles y entrada' : 'Croquis ilustrado de Arturo con solares identificados, calles, caño, área verde y entrada');
  plotSourceToggle.setAttribute('aria-pressed', String(original));
  plotSourceToggle.textContent = original
    ? (en ? 'View illustrated map' : 'Ver plano ilustrado')
    : (en ? 'View original plan' : 'Ver plano original');
});
document.querySelectorAll('[data-map-focus]').forEach(button => button.addEventListener('click', () => {
  const point = mapLandmarks[button.dataset.mapFocus];
  if (point) centerMapPoint(...point);
}));

plots.forEach(plot => {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'lot-hotspot';
  button.dataset.id = plot.id;
  button.style.left = `${plot.x}%`;
  button.style.top = `${plot.y}%`;
  const number = document.createElement('b');
  number.className = 'lot-number';
  number.textContent = plot.id.slice(-2);
  button.append(number);
  button.addEventListener('click', () => selectPlot(plot));
  plotHotspots.append(button);
});
plotFilterButtons.forEach(button => button.addEventListener('click', () => {
  plotFilter = button.dataset.filter;
  if (!isPlotVisible(selectedPlot)) {
    selectedPlot = plots.find(isPlotVisible);
    updatePlotUrl(selectedPlot);
  }
  renderPlotInterface();
  centerPlot(selectedPlot);
}));
document.getElementById('plot-view-open').addEventListener('click', () => plotViewDialog.showModal());
document.getElementById('plot-view-close').addEventListener('click', () => plotViewDialog.close());
document.getElementById('plot-view-prev').addEventListener('click', () => changeLandscapeView(-1));
document.getElementById('plot-view-next').addEventListener('click', () => changeLandscapeView(1));
plotViewDialog.addEventListener('click', event => { if (event.target === plotViewDialog) plotViewDialog.close(); });
document.getElementById('plot-zoom-out').addEventListener('click', () => {
  plotZoomIndex = Math.max(0, plotZoomIndex - 1);
  updatePlotCanvasWidth();
  centerPlot(selectedPlot);
});
document.getElementById('plot-zoom-in').addEventListener('click', () => {
  plotZoomIndex = Math.min(zoomSteps.length - 1, plotZoomIndex + 1);
  updatePlotCanvasWidth();
  centerPlot(selectedPlot);
});
window.addEventListener('resize', () => { updatePlotCanvasWidth(); centerPlot(selectedPlot, false); }, { passive: true });
plotSave.addEventListener('click', () => {
  savedPlotId = savedPlotId === selectedPlot.id ? null : selectedPlot.id;
  let persisted = true;
  try {
    if (savedPlotId) window.localStorage.setItem('vista-verde-plot', savedPlotId);
    else window.localStorage.removeItem('vista-verde-plot');
  } catch (_) { persisted = false; }
  renderPlotInterface();
  plotFeedback.textContent = !persisted
    ? (plotLanguage() === 'en' ? 'Selection is active for this visit only.' : 'La selección queda activa solo durante esta visita.')
    : plotLanguage() === 'en'
      ? (savedPlotId ? 'Saved in this browser. This is not a reservation.' : 'Selection removed.')
      : (savedPlotId ? 'Guardada en este navegador. No constituye una reserva.' : 'Selección eliminada.');
});
plotShare.addEventListener('click', async () => {
  const url = new URL(window.location.href);
  url.searchParams.set('solar', selectedPlot.id);
  url.hash = 'solares';
  try {
    if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(url.toString());
    else {
      const input = document.createElement('textarea');
      input.value = url.toString();
      input.style.position = 'fixed'; input.style.opacity = '0';
      document.body.append(input); input.select();
      if (!document.execCommand('copy')) throw new Error('copy unavailable');
      input.remove();
    }
    plotFeedback.textContent = plotLanguage() === 'en' ? 'Link copied with this plot selected.' : 'Enlace copiado con este solar seleccionado.';
  } catch (_) {
    plotFeedback.textContent = plotLanguage() === 'en' ? 'Your browser could not copy the link.' : 'El navegador no pudo copiar el enlace.';
  }
});

// Local synthetic ambience: it is deliberately not represented as field audio.
let ambienceContext = null;
let ambienceMaster = null;
let ambienceEnabled = false;
let ambienceSuspendTimer = null;
const ambientToggle = document.getElementById('ambient-toggle');
async function createAmbience() {
  const Context = window.AudioContext || window.webkitAudioContext;
  if (!Context) throw new Error('Web Audio unavailable');
  ambienceContext = new Context();
  const length = Math.floor(ambienceContext.sampleRate * 5);
  const buffer = ambienceContext.createBuffer(1, length, ambienceContext.sampleRate);
  const samples = buffer.getChannelData(0);
  let softened = 0;
  for (let i = 0; i < length; i++) {
    const white = Math.random() * 2 - 1;
    softened = softened * .985 + white * .015;
    const edge = Math.min(1, i / (ambienceContext.sampleRate * .18), (length - i - 1) / (ambienceContext.sampleRate * .18));
    samples[i] = (white * .14 + softened * .86) * Math.max(0, edge);
  }
  const source = ambienceContext.createBufferSource();
  source.buffer = buffer; source.loop = true;
  ambienceMaster = ambienceContext.createGain();
  ambienceMaster.gain.value = 0;
  ambienceMaster.connect(ambienceContext.destination);
  const breeze = ambienceContext.createBiquadFilter();
  breeze.type = 'lowpass'; breeze.frequency.value = 520;
  const breezeLevel = ambienceContext.createGain(); breezeLevel.gain.value = .85;
  const water = ambienceContext.createBiquadFilter();
  water.type = 'bandpass'; water.frequency.value = 1300; water.Q.value = .32;
  const waterLevel = ambienceContext.createGain(); waterLevel.gain.value = .16;
  source.connect(breeze).connect(breezeLevel).connect(ambienceMaster);
  source.connect(water).connect(waterLevel).connect(ambienceMaster);
  source.start();
}
async function setAmbience(enabled) {
  clearTimeout(ambienceSuspendTimer);
  if (enabled) {
    try {
      if (!ambienceContext) await createAmbience();
      await ambienceContext.resume();
    } catch (_) {
      ambientToggle.disabled = true;
      plotFeedback.textContent = plotLanguage() === 'en' ? 'Audio is unavailable in this browser.' : 'El audio no está disponible en este navegador.';
      return;
    }
  }
  ambienceEnabled = enabled;
  if (ambienceContext && ambienceMaster) {
    const now = ambienceContext.currentTime;
    ambienceMaster.gain.cancelScheduledValues(now);
    ambienceMaster.gain.setTargetAtTime(enabled ? .13 : 0, now, .18);
    if (!enabled) ambienceSuspendTimer = window.setTimeout(() => { if (!ambienceEnabled) ambienceContext.suspend(); }, 700);
  }
  ambientToggle.setAttribute('aria-pressed', String(enabled));
  renderPlotInterface();
}
ambientToggle.addEventListener('click', () => setAmbience(!ambienceEnabled));
document.addEventListener('visibilitychange', () => { if (document.hidden && ambienceEnabled) setAmbience(false); });
window.addEventListener('pagehide', () => { if (ambienceContext) ambienceContext.close(); });

activeLandscapeView = (Number(selectedPlot.id.slice(-2)) * 7 + 2) % realLandscapeViewCount;
updatePlotCanvasWidth();
renderPlotInterface();
if (linkedPlot || savedPlot) centerPlot(selectedPlot, false);

// Keep discovery chapters mutually exclusive in browsers without details[name] support.
const discoveryChapters = Array.from(document.querySelectorAll('#experiencias > details'));
discoveryChapters.forEach(chapter => chapter.addEventListener('toggle', () => {
  if (!chapter.open) return;
  discoveryChapters.forEach(other => { if (other !== chapter) other.open = false; });
}));

// Each discovery gallery supports touch, buttons and keyboard navigation.
document.querySelectorAll('.flora-exhibit').forEach(exhibit => {
  const floraRail = exhibit.querySelector('.flora-rail');
  const specimens = Array.from(floraRail.querySelectorAll('.flora-specimen'));
  const floraPrev = exhibit.querySelector('.flora-prev');
  const floraNext = exhibit.querySelector('.flora-next');
  const floraCount = exhibit.querySelector('.flora-count');
  const progress = document.createElement('div');
  progress.className = 'gallery-progress';
  progress.setAttribute('aria-hidden', 'true');
  progress.innerHTML = '<span></span>';
  floraRail.insertAdjacentElement('afterend', progress);
  const progressFill = progress.firstElementChild;
  let activeSpecimen = 0;
  let scrollFrame = 0;
  const updateFloraControls = index => {
    activeSpecimen = Math.max(0, Math.min(specimens.length - 1, index));
    floraCount.textContent = `${String(activeSpecimen + 1).padStart(2, '0')} / ${String(specimens.length).padStart(2, '0')}`;
    progressFill.style.width = `${((activeSpecimen + 1) / specimens.length) * 100}%`;
    floraPrev.disabled = activeSpecimen === 0;
    floraNext.disabled = activeSpecimen === specimens.length - 1;
  };
  const showSpecimen = index => {
    const next = Math.max(0, Math.min(specimens.length - 1, index));
    updateFloraControls(next);
    floraRail.scrollTo({ left: specimens[next].offsetLeft - specimens[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  floraPrev.addEventListener('click', () => showSpecimen(activeSpecimen - 1));
  floraNext.addEventListener('click', () => showSpecimen(activeSpecimen + 1));
  floraRail.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      showSpecimen(activeSpecimen + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  floraRail.addEventListener('scroll', () => {
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(() => {
      const left = floraRail.scrollLeft + specimens[0].offsetLeft;
      const nearest = specimens.reduce((best, specimen, index) =>
        Math.abs(specimen.offsetLeft - left) < Math.abs(specimens[best].offsetLeft - left) ? index : best, 0);
      updateFloraControls(floraRail.scrollLeft >= floraRail.scrollWidth - floraRail.clientWidth - 4 ? specimens.length - 1 : nearest);
    });
  }, { passive: true });
  updateFloraControls(0);
});
